import { render, staticRenderFns } from "./EditExtraType.vue?vue&type=template&id=2eefa486&"
import script from "./EditExtraType.vue?vue&type=script&lang=js&"
export * from "./EditExtraType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports